import moment from 'moment';
/*
checkIdCard(ID)验证身份证号码
返回值：0 : "是正确的身份证号"
        1 : "身份证校验不符合求和模11=1这个等式",
        2 : "身份证最后一位校验位有误",
        3 : "身份证位数不正确",
        4 : "年份错误",
        5 : "月份错误",
        6 : "日错误"
        
*/
export function checkIdCard(ID) {
    var ck = new IDCard();
    ck.check(ID);
    return ck.errNum;
}

function IDCard(ID) {
    var me = this;
    this.checkCode = new Array(1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2);
    this.ID;
    this.errNum = 0;
    this.err = {
        1: "身份证校验不符合求和模11=1这个等式",
        2: "身份证最后一位校验位有误",
        3: "身份证位数不正确",
        4: "年份错误",
        5: "月份错误",
        6: "日错误"
    };
    this.err_msg = function () {
        return (0 !== this.errNum) ? this.err[this.errNum] : null;
    };
    this.check = function (ID) {
        this.errNum = 0;
        this.ID = ID;
        if (cardValidate()) {
            if (!aiCheck()) this.errNum = 1;
            if (!LastByteCheck()) this.errNum = 2;
            return (0 === this.errNum) ? true : false;
        } else {
            return false;
        }
    };

    function getNum(str) {
        var re = /^[0]*([0-9]*)$/;
        str.match(re);
        return parseInt(RegExp.$1, 10);
    }
    //对身份证位数，出生日期，初步验证
    function cardValidate() {
        var re = /^[0-9x]{15,18}$/i;
        if (!re.test(me.ID)) {
            me.errNum = 7;
            return false;
        }
        if (15 == me.ID.length || 18 == me.ID.length) {
            var realLen = 0;
            if (18 == me.ID.length) realLen = 2;
            var year = parseInt(me.ID.substr(6, 2 + realLen), 10);
            var month = getNum(me.ID.substr(8 + realLen, 2));
            var day = parseInt(me.ID.substr(10 + realLen, 2), 10);
            if (4 == year.length)
                if (year < 1900 || year > 2050) me.errNum = 4;
            if (month < 1 || month > 12) me.errNum = 5;
            if (day < 1 || day > 31) me.errNum = 6;
            return 0 === me.errNum;
        } else {
            me.errNum = 3;
            return false;
        }
    }
    //总和模11应该等于1
    var aiCheck = function () {
        var sum = 0;
        for (var i = 1; i <= me.ID.length; i++) {
            var ai = me.ID.substr(me.ID.length - i, 1);
            ai = (ai.toLowerCase() == 'x') ? 10 : ai;
            var wi = Math.pow(2, i - 1) % 11;
            sum += parseInt(ai, 10) * wi;
        }
        return 1 == sum % 11;
    };
    //最后一位校验，这个可以和aiCheck合在一起，减少一次循环
    var LastByteCheck = function () {
        var sum = 0;
        for (var i = 2; i <= me.ID.length; i++) {
            var ai = me.ID.substr(me.ID.length - i, 1);
            ai = (ai.toLowerCase() == 'x') ? 10 : ai;
            var wi = Math.pow(2, i - 1) % 11;
            sum += parseInt(ai, 10) * wi;
        }
        var checkCodeIndex = sum % 11;
        var c = me.ID.substr(me.ID.length - 1, 1);
        //alert(c+"=="+me.checkCode[checkCodeIndex]);
        return c == me.checkCode[checkCodeIndex];
    };
}

export function getSex(idcardNumber) {
    if (parseInt(idcardNumber.substr(16, 1)) % 2 == 1) {
        return '1';
    } else {
        return '2';
    }
}

export function getBirthday(idcardNumber) {
    return idcardNumber.substr(6, 8);
}

//获取年龄
export function getAge(idcardNumber) {
    var birth = getBirthday(idcardNumber);
    var now = new Date();
    var today = moment(now).format("YYYYMMDD");

    var age = parseInt(today.substr(0, 4)) - parseInt(birth.substr(0, 4));
    if (today.substr(4, 4) < birth.substr(4, 4)) {
        age--;
    }
    return age;
}

export function getAgeFromBirth(birth) {
    var now = new Date();
    var today = moment(now).format("YYYYMMDD");

    var age = parseInt(today.substr(0, 4)) - parseInt(birth.substr(0, 4));
    if (today.substr(4, 4) < birth.substr(4, 4)) {
        age--;
    }
    return age;
}

// 校验手机号是否正确
export function checkPhoneNumber(num) {
    var myreg = /^[1][0-9]{10}$/;
    //var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
    if (!myreg.test(num)) {
        return false;
    } else {
        return true;
    }
}

// 是否强密码
// 8-16位，必须同时包含字母和数字
export function isStrongPassword(pwd, securityLevel) {
    if (securityLevel == undefined || securityLevel == null) {
        securityLevel = 3;
    }
    if (securityLevel == 0) {
        //简单密码,只做长度验证
        var regex = /^.{8,16}$/;
        var errMsg = '密码长度必须为8-16位';
        var result = regex.test(pwd);
        return {
            result: result,
            errMsg: result ? "" : errMsg
        }
    } else if (securityLevel == 1) {
        //8-16位，必须同时包含字母和数字,不能包含特殊字符
        var regex = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
        var errMsg = '8-16位，必须同时包含字母和数字';
        var result = regex.test(pwd);
        return {
            result: result,
            errMsg: result ? "" : errMsg
        }
    } else if (securityLevel == 2) {
        //8-16位,必须至少同时包含字母和数字,特殊字符中的两种
        var regex = /^(?!\d+$)(?!^[a-zA-Z]+$)(?!^[_~!@#$%^&*]+$){8,16}$/;
        var errMsg = "8-16位,必须至少同时包含字母和数字,特殊字符中的两种组合";
        var result = regex.test(pwd);
        return {
            result: result,
            errMsg: result ? "" : errMsg
        }
    } else if (securityLevel == 3) {
        //8-16位,必须至少同时包含大字母、小写字母、数字、特殊字符（~!@#$%^&*) 四种中的三种

        // (?![\da-z]+$) 不能全是数字和小写字母的组合
        // (?![\dA-Z]+$) 不能全是数字和大写字母的组合
        // (?![\d~!@#$%^&*]+$) 不能全是数字和特殊的组合
        // (?![a-zA-Z]+$) 不能全是大小写字母的组合
        // (?![a-z~!@#$%^&*]+$) 不能全是小写字母和字符的组合
        // (?![A-Z~!@#$%^&*]+$) 不能全是大写字母和字符的组合
        // [\da-zA-z~!@#$%^&*]{8,16}$/; 可用的文本和长度限制

        var regex = /^(?![\da-z]+$)(?![\dA-Z]+$)(?![\d~!@#$%^&*]+$)(?![a-zA-Z]+$)(?![a-z~!@#$%^&*]+$)(?![A-Z~!@#$%^&*]+$)[\da-zA-z~!@#$%^&*]{8,16}$/;
        var errMsg = '8-16位,必须至少同时包含大字母、小写字母、数字、特殊字符中的三种'
        var result = regex.test(pwd);
        return {
            result: result,
            errMsg: result ? "" : errMsg
        }
    } else {
        return {
            result: false,
            errMsg: "无效的密码安全级别参数"
        }
    }
    //return regex.test(pwd);
}